// extracted by mini-css-extract-plugin
export default {"layout":"_8457821d38 _2381dfb417 _2e44261481","h_slide":"a87b31f47a","category":"_6dfed07a79 fcc264e83e _881dc0f99d"};